import React from 'react';
import styled from 'styled-components';
import { StaticImage } from "gatsby-plugin-image"
import colors from '../../../../helpers/colors';

const Wrapper = styled.div`
    padding: 80px 40px 50px 40px;

    @media (max-width: 769px) {
        padding: 150px 20px 150px 20px;
    }
    @media (max-width: 500px) {
        flex-direction: column;
        padding: 100px 28px 50px 28px;
    }
`;

const FlexContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 800px;
    margin: 0 auto;

    @media (max-width: 1050px) {
        width: 100%;
    }

    @media (max-width: 769px) {
        flex-wrap: wrap;
        justify-content: center;
    }

    @media (max-width: 500px) {
        flex-direction: column;
    }
`;

const Title = styled.h3`
    font-size: 35px;
    font-weight: 900;
    color: ${colors.mvDarkGrey};
    text-align: center;
    max-width: 50%;
    margin: 0 auto;
    line-height: 1.5;

    @media (min-width: 1500px) {
        max-width: 40%;
    }
    @media (max-width: 1000px) {
        width: 80%;
        max-width: none;
    }

    @media (max-width: 769px) {
        font-size: 30px;
    }

    @media (max-width: 500px) {
        width: 100%;
        font-size: 25px;
    }

`;

const Subtitle = styled.p`
    color: ${colors.paragraphTextColor};
    font-weight: 700;
    font-size: 15px;
    margin: 0 auto;
    text-align: center;

    @media (max-width: 769px) {
        max-width: 100%;
        padding: 0 15px;
    }

    @media (max-width: 500px) {
        font-size: 15px;
    }
`;

const Description = styled.p`
    font-size: 16px;
    color: ${colors.paragraphTextColor};
    line-height: 1.5;
    width: 1029px;
    margin: 20px auto 50px auto;
    text-align: center;

    @media (max-width: 1150px) {
        width: 100%;
    }
`;

const PillarContainer = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    position: relative;
    margin: 0 30px;
    width: 220px;


    @media (max-width: 1100px) {
        max-width: none;
        width: 30%;
        margin: 0 20px;
    }

    @media (max-width: 1050px) {
        width: 33%;
        margin: 0 5px;
    }

    @media (max-width: 769px) {
        margin: 30px;
        width: 100%;
    }
    @media (max-width: 500px) {
        margin: 25px 0;
    }
`;

const ImageContainer = styled.div`
    margin: 0 auto;
    width: 60px;
`;

const PillarTitle = styled.h3`
    font-size: 20px;
    font-weight: 900;
    color: ${colors.mvDarkGrey};
    margin: 20px 0 8px 0;  
`;

const PillarDescription = styled.p`
    font-size: 15px;
    color: ${colors.paragraphTextColor};
    line-height: 1.5;
`;

const PillarsSection = () => {

    return (
        <Wrapper>
            <Title>What is it like to be a MVer?</Title>
            <Subtitle>A MVer is a Motivosity team member.</Subtitle>
            <Description>
                Motivosity was founded on a culture of three things: Love What You Do, Serve Always and Stay Young. 
                We live up to our values and would only expect a future MVer to do the same. We have a fun, fast-paced environment. 
                We also believe work-life balance should be a priority and live by the motto of “Be honest with Motivosity, and do what you gotta do.”
            </Description>
            
            <FlexContainer>
                {/* <PillarContainer>
                    <ImageContainer>
                        <StaticImage src="../../../../resources/images/careers/lehi.png" alt="Mountain icon with a circle background" quality="100" />
                    </ImageContainer>
                    <PillarTitle>Lehi</PillarTitle>
                    <PillarDescription>We are mainly based out of Lehi, Utah, and eat wayyy too many tacos from Don Joaquin's.</PillarDescription>
                </PillarContainer> 

                <PillarContainer>
                    <ImageContainer>
                        <StaticImage src="../../../../resources/images/careers/hungary.png" alt="City icon with a circle background" quality="100" />
                    </ImageContainer>
                    <PillarTitle>Hungary</PillarTitle>
                    <PillarDescription>Known for its hot springs and thermal spas, it's home to some of our skilled developers.</PillarDescription>
                </PillarContainer>    */}
{/* 
                <PillarContainer>
                    <ImageContainer>
                        <StaticImage src="../../../../resources/images/careers/remote.png" alt="Globe icon with a circle background" quality="100" />
                    </ImageContainer>
                    <PillarTitle>Remote</PillarTitle>
                    <PillarDescription>Don't live near one of our offices? No problem—we are open to remote work!</PillarDescription>
                </PillarContainer>  */}
            </FlexContainer>
        </Wrapper>
    );
};

export default PillarsSection;
